/**
 * 轻提示 (Toast).
 *
 * 模板里用 `$store.toast.show('...')`, TS 组件里用本文件导出的 toast() 包装,
 * 两者都指向同一个 Alpine 响应式 store 实例。
 */

export interface ToastStore {
  message: string
  visible: boolean
  show(message: string, duration?: number): void
}

const DEFAULT_DURATION = 1600

export function toastStore(): ToastStore {
  let timer: number | undefined

  return {
    message: '',
    visible: false,

    show(message, duration = DEFAULT_DURATION) {
      this.message = message
      this.visible = true
      window.clearTimeout(timer)
      timer = window.setTimeout(() => {
        this.visible = false
      }, duration)
    },
  }
}

/** 供 TS 组件调用: 通过 Alpine store 代理触发响应式更新 */
export function toast(message: string): void {
  // Alpine.store() 的泛型参数是 store 名称(key), 不是值类型, 因此这里做一次断言
  const store = window.Alpine?.store('toast') as ToastStore | undefined
  store?.show(message)
}
